import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ResponseEffects } from './Effects/responses.effects';

@NgModule({
  imports: [
    EffectsModule.forRoot([ResponseEffects])
  ]
})
export class ResponseStoreModule { }
